import { Theme } from '@mui/material'

const classes = {
  fab: (theme: Theme, isMobile: boolean) => ({
    position: 'fixed',
    right: isMobile ? 16 : 32,
    bottom: 32,
    zIndex: theme.zIndex.fab,
  }),
  icon: (isMobile: boolean) => ({
    marginRight: isMobile ? 0 : 1,
  }),
}

export default classes
